import { render, staticRenderFns } from "./HSCodesHead.vue?vue&type=template&id=27cc65f6"
import script from "./HSCodesHead.vue?vue&type=script&lang=js"
export * from "./HSCodesHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports